/* eslint-disable no-console */
/* eslint-disable react/no-array-index-key */
/* eslint-disable no-lonely-if */
import React from "react";
import { Checkbox } from "antd";
import ModuleHeader from "./ModuleHeader";
import PermissionTitle from "./PermissionTitle";
import { PERMISSIONS } from "../../Login/constants";
import {
  powerAfricaAssetAddEditDelete,
  powerAfricaAssetChecklistAddEditDelete,
  powerAfricaAssetrAddService,
  powerAfricaAssetViewQR,
} from "./permissionFunctions";
import { powerAfricaAssetPermissions } from "./data";
import SessionIcon from "../../../Common/Svgs/SessionIcon";

const CONDITIONS = {
  VIEW_AND_EDIT: [
    PERMISSIONS.POWER_AFRICA_ASSET_VIEW,
    PERMISSIONS.POWER_AFRICA_ASSET_NO_ACCESS,
  ],
  // VIEW_ONLY: ["trike_view_and_edit", "trike_no_access"],
  // NO_ACCESS: ["trike_view_and_edit", PERMISSIONS.TRIKE_VIEW],
  REMOVE_ALL: [
    PERMISSIONS.POWER_AFRICA_ASSET_ADD,
    PERMISSIONS.POWER_AFRICA_ASSET_EDIT,
    PERMISSIONS.POWER_AFRICA_ASSET_DELETE,
    PERMISSIONS.POWER_AFRICA_ASSET_CHECKLIST_ADD,
    PERMISSIONS.POWER_AFRICA_ASSET_CHECKLIST_EDIT,
    PERMISSIONS.POWER_AFRICA_ASSET_CHECKLIST_DELETE,
    PERMISSIONS.POWER_AFRICA_ASSET_ISSUE_ADD,
    PERMISSIONS.POWER_AFRICA_ASSET_ISSUE_VIEW,
    PERMISSIONS.POWER_AFRICA_ASSET_ADD_TO_SERVICE,
    PERMISSIONS.POWER_AFRICA_ASSET_VIEW_QR,
    PERMISSIONS.POWER_AFRICA_ASSET_NO_SERVICE,
    PERMISSIONS.POWER_AFRICA_ASSET_NO_QR,
    PERMISSIONS.POWER_AFRICA_ASSET_VIEW,
    PERMISSIONS.POWER_AFRICA_ASSET_VIEW_AND_EDIT,
    PERMISSIONS.POWER_AFRICA_ASSET_NO_ACCESS,
  ],
};

const PowerAfricaAssetPermissions = ({ permissions, setPermissions }) => {
  // check if the permissions needs to be disabled
  const disabled = CONDITIONS.VIEW_AND_EDIT.some((d) =>
    permissions.includes(d),
  );

  const handleModulePermission = (permissionId) => {
    let local = [];

    if (permissionId === PERMISSIONS.POWER_AFRICA_ASSET_VIEW_AND_EDIT) {
      local = permissions.filter(
        (item) => !CONDITIONS.VIEW_AND_EDIT.includes(item),
      );
    }

    // removing all the power africa asset permissions
    if (permissionId === PERMISSIONS.POWER_AFRICA_ASSET_VIEW) {
      local = permissions.filter(
        (item) => !CONDITIONS.REMOVE_ALL.includes(item),
      );
    }

    // removing all the power africa asset permissions
    if (permissionId === PERMISSIONS.POWER_AFRICA_ASSET_NO_ACCESS) {
      local = permissions.filter(
        (item) => !CONDITIONS.REMOVE_ALL.includes(item),
      );
    }

    setPermissions([...local, permissionId]);
  };

  const handleIndividualPermission = (permissionId) => {
    let local = [];

    if (permissions.includes(permissionId)) {
      local = permissions.filter((item) => item !== permissionId);
      setPermissions(local);
    } else {
      if (permissionId === PERMISSIONS.POWER_AFRICA_ASSET_ADD) {
        // handling multiple insertions for power africa asset add, edit, delete
        powerAfricaAssetAddEditDelete({ setPermissions });
      } else if (
        permissionId === PERMISSIONS.POWER_AFRICA_ASSET_CHECKLIST_ADD
      ) {
        // handling multiple insertions for power africa asset checklist add, edit, delete
        powerAfricaAssetChecklistAddEditDelete({ setPermissions });
      } else if (
        permissionId === PERMISSIONS.POWER_AFRICA_ASSET_ADD_TO_SERVICE ||
        permissionId === PERMISSIONS.POWER_AFRICA_ASSET_NO_SERVICE
      ) {
        // handling either add or don't add to service
        powerAfricaAssetrAddService({
          current: permissionId,
          permissions,
          setPermissions,
        });
      } else if (
        permissionId === PERMISSIONS.POWER_AFRICA_ASSET_VIEW_QR ||
        permissionId === PERMISSIONS.POWER_AFRICA_ASSET_NO_QR
      ) {
        // handling either view or don't view QR
        powerAfricaAssetViewQR({
          current: permissionId,
          permissions,
          setPermissions,
        });
      } else {
        setPermissions((prev) => [...prev, permissionId]);
      }
    }
  };

  return (
    <div>
      <ModuleHeader
        module="Agri-tech"
        icon={<SessionIcon size={16} className="text-primary" />}
      />
      {/* main module permission */}
      <div className="w-full h-[60px]">
        <div
          className="flex items-center w-full h-full border-b"
          style={{
            background: "#FAF2D8",
            borderColor: "#FAD152",
          }}
        >
          <div
            className="w-[40%] border-r py-3 px-6"
            style={{
              borderColor: "#FAD152",
            }}
          >
            <PermissionTitle
              title={powerAfricaAssetPermissions[0].title}
              description={powerAfricaAssetPermissions[0].description}
            />
          </div>

          <div className="w-[60%] h-full flex items-center">
            {powerAfricaAssetPermissions[0].options.map((option) => {
              // rendering empty div for layout consistency
              if (!option) {
                return (
                  <div
                    className="w-[25%] border-r px-6 h-full flex items-center gap-x-2"
                    style={{
                      borderColor: "#FAD152",
                    }}
                  />
                );
              }

              const selected = permissions.includes(option.permissionId);

              return (
                <div
                  key={option.text}
                  className="w-[25%] border-r px-6 h-full flex items-center gap-x-2"
                  style={{
                    borderColor: "#FAD152",
                  }}
                >
                  <Checkbox
                    checked={selected}
                    onClick={() => handleModulePermission(option.permissionId)}
                  />
                  <p
                    className={`font-poppins text-xs ${
                      selected ? "font-medium" : "font-normal"
                    }`}
                  >
                    {option.text}
                  </p>
                </div>
              );
            })}
          </div>
        </div>
      </div>

      {/* individual functionality permission */}
      <div className="w-full">
        {powerAfricaAssetPermissions.slice(1).map((item) => {
          return (
            <div
              key={item.id}
              className="flex items-center w-full h-[60px] border-b"
              style={{
                borderColor: "#DFDFDF",
              }}
            >
              <div
                className="w-[40%] h-full border-r py-3 px-6"
                style={{
                  borderColor: "#DFDFDF",
                }}
              >
                <PermissionTitle
                  title={item.title}
                  description={item.description}
                />
              </div>

              <div className="w-[60%] h-full flex items-center">
                {item.options.map((option, idx) => {
                  // rendering empty div for layout consistency
                  if (!option) {
                    return (
                      <div
                        key={idx}
                        className="w-[25%] h-full border-r px-6 flex items-center gap-x-2"
                        style={{
                          borderColor: "#DFDFDF",
                        }}
                      />
                    );
                  }

                  const selected = permissions.includes(option.permissionId);

                  // if the permission is view only, remove pointer events and add an opacity
                  return (
                    <div
                      key={option.text}
                      className="w-[25%] h-full border-r px-6 flex items-center gap-x-2"
                      style={{
                        borderColor: "#DFDFDF",
                        opacity: disabled && 0.5,
                        pointerEvents: disabled && "none",
                      }}
                    >
                      {/* if the permissions should be disabled then it should not
                      show any tick mark else show the selected tick mark */}
                      <Checkbox
                        checked={disabled ? false : selected}
                        onClick={() =>
                          handleIndividualPermission(option.permissionId)
                        }
                      />
                      <p
                        className={`font-poppins text-xs
                        ${selected ? "font-medium" : "font-normal"}
                        `}
                      >
                        {option.text}
                      </p>
                    </div>
                  );
                })}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default PowerAfricaAssetPermissions;
